import type { CodeLine, SiteData, TechKey } from './types';

const SNIPPETS: Record<TechKey, CodeLine[]> = {
  stripe: [
    ['<!-- Stripe.js v3 -->', 'comment', null],
    ['<script src="https://js.stripe.com/v3/"></script>', 'trigger', 'stripe'],
    ['<script>', 'normal', null],
    ["  var stripe = Stripe('pk_live_51Hg3xK...');", 'bright', null],
  ],
  shopify: [
    ['<!-- Shopify Platform -->', 'comment', null],
    ['window.Shopify = window.Shopify || {};', 'normal', null],
    ['Shopify.shop = "acme-store.myshopify.com";', 'trigger', 'shopify'],
  ],
  hubspot: [
    ['<!-- Start of HubSpot Embed Code -->', 'comment', null],
    ['<script type="text/javascript" id="hs-script-loader"', 'normal', null],
    [
      '  async defer src="//js.hs-scripts.com/47290182.js">',
      'trigger',
      'hubspot',
    ],
  ],
  mixpanel: [
    ['<!-- Mixpanel -->', 'comment', null],
    [
      '<script>(function(f,b){var e,d,a,c;e=f.createElement(b);',
      'normal',
      null,
    ],
    [
      '  e.src="https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"',
      'trigger',
      'mixpanel',
    ],
  ],
  google_adsense: [
    ['<!-- Google AdSense -->', 'comment', null],
    [
      '<script async src="https://pagead2.googlesyndication.com',
      'normal',
      null,
    ],
    [
      '  /pagead/js/adsbygoogle.js?client=ca-pub-8273649102345678"',
      'trigger',
      'google_adsense',
    ],
  ],
  segment: [
    ['<!-- Segment -->', 'comment', null],
    ['<script>!function(){var analytics=window.analytics=', 'normal', null],
    [
      '  window.analytics||[];analytics.load("Xk9mNp3yQ8rA4bFj");',
      'trigger',
      'segment',
    ],
  ],
  klaviyo: [
    ['<!-- Klaviyo -->', 'comment', null],
    ['<script async type="text/javascript"', 'normal', null],
    [
      '  src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RbT4Xq"></script>',
      'trigger',
      'klaviyo',
    ],
  ],
  intercom: [
    ['<!-- Intercom -->', 'comment', null],
    ['<script>window.intercomSettings={api_base:', 'normal', null],
    [
      '  "https://api-iam.intercom.io",app_id:"f3k9p2xw"};</script>',
      'trigger',
      'intercom',
    ],
  ],
};

export function makeCodeForSite(site: SiteData): CodeLine[] {
  const boilerplate: CodeLine[] = [
    ['<!DOCTYPE html>', 'dim', null],
    ['<html lang="en">', 'dim', null],
    ['  <head>', 'dim', null],
    ['    <meta charset="UTF-8">', 'dim', null],
    ['    <meta name="viewport" content="width=device-width">', 'dim', null],
    [`    <title>${site.host}</title>`, 'normal', null],
    ['    <link rel="stylesheet" href="/assets/main.min.css">', 'dim', null],
    ['', 'dim', null],
  ];

  const lines: CodeLine[] = [...boilerplate];
  site.techs.forEach((key) => {
    SNIPPETS[key].forEach((line) => {
      lines.push([`    ${line[0]}`, line[1], line[2]]);
    });
    lines.push(['', 'dim', null]);
  });
  lines.push(['  </head>', 'dim', null]);
  lines.push(['  <body>', 'dim', null]);
  lines.push(['    <div id="app"></div>', 'dim', null]);
  return lines;
}

export function hexToRgbaColor(hex: string, alpha: number): string {
  const red = parseInt(hex.slice(1, 3), 16);
  const green = parseInt(hex.slice(3, 5), 16);
  const blue = parseInt(hex.slice(5, 7), 16);
  return `rgba(${red},${green},${blue},${alpha})`;
}
